export const REDACTED_PATH_PARAM = ":REDACTED";

export const sendgridApiHosts = ["api.sendgrid.com", "api.staging.sendgrid.com"];

export const httpResourceTypes = ["xhr", "fetch"];
